<template>
    <main>
        <div class="service" @click="toService"></div>
    </main>
</template>

<script>
    export default {
        name: 'service',
        data() {
            return {}
        },
        components:{

        },
        computed:{

        },
        methods: {
			toService(){
				gio('track', 'DTF2021_chatclick');
				this.util.toLink('https://url.cn/5O0aZr9?_type=wpa&qidian=true','','_blank')
			}
        },
        mounted() {
            this.query = this.$route.query;
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .service{position: fixed;right:-.12rem;top:50%;width: 1rem;height:1rem;background: url("~@/assets/image/86.png") no-repeat center center;background-size: contain;z-index: 80;cursor: pointer;transition: all .3s ease;}
</style>

